export const MENU_EQUIPMENTS = 'MENU_EQUIPMENTS'

// Menu Equipments Actions
export const FETCH_MENU_EQUIPMENTS = `${MENU_EQUIPMENTS}/fetchMenuEquipments`
export const FETCH_MENU_EQUIPMENT_BY_ID = `${MENU_EQUIPMENTS}/fetchMenuEquipmentById`
export const CREATE_MENU_EQUIPMENT = `${MENU_EQUIPMENTS}/createMenuEquipment`
export const UPDATE_MENU_EQUIPMENT = `${MENU_EQUIPMENTS}/updateMenuEquipment`
export const DELETE_MENU_EQUIPMENT = `${MENU_EQUIPMENTS}/deleteMenuEquipment`

// Menu Equipment Product Mapping Actions
export const FETCH_EQUIPMENT_MAPPINGS = `${MENU_EQUIPMENTS}/fetchEquipmentMappings`
export const FETCH_EQUIPMENT_MAPPING_BY_ID = `${MENU_EQUIPMENTS}/fetchEquipmentMappingById`
export const CREATE_EQUIPMENT_MAPPING = `${MENU_EQUIPMENTS}/createEquipmentMapping`
export const UPDATE_EQUIPMENT_MAPPING = `${MENU_EQUIPMENTS}/updateEquipmentMapping`
export const DELETE_EQUIPMENT_MAPPING = `${MENU_EQUIPMENTS}/deleteEquipmentMapping`
export const BULK_UPSERT_EQUIPMENT_MAPPINGS = `${MENU_EQUIPMENTS}/bulkUpsertEquipmentMappings`

// Restaurant Menu Equipment Actions
export const BULK_UPSERT_RESTAURANT_MENU_EQUIPMENTS = `${MENU_EQUIPMENTS}/bulkUpsertRestaurantMenuEquipments`
export const FETCH_RESTAURANT_MENU_EQUIPMENTS = `${MENU_EQUIPMENTS}/fetchRestaurantMenuEquipments`
export const UPDATE_RESTAURANT_MENU_EQUIPMENT = `${MENU_EQUIPMENTS}/updateRestaurantMenuEquipment`
export const CREATE_RESTAURANT_MENU_EQUIPMENT = `${MENU_EQUIPMENTS}/createRestaurantMenuEquipment`
export const BULK_UPDATE_RESTAURANT_MENU_EQUIPMENT_STATUS = `${MENU_EQUIPMENTS}/bulkUpdateRestaurantMenuEquipmentStatus`
export const PREVIEW_BULK_UPDATE_RESTAURANT_MENU_EQUIPMENT_STATUS = `${MENU_EQUIPMENTS}/previewBulkUpdateRestaurantMenuEquipmentStatus`
export const PREVIEW_EQUIPMENT_PRODUCT_STORE = `${MENU_EQUIPMENTS}/previewEquipmentProductStore`
export const CREATE_EQUIPMENT_PERMANENT_DISABLE_REQUEST = `${MENU_EQUIPMENTS}/createEquipmentPermanentDisableRequest`
export const FETCH_EQUIPMENT_PERMANENT_DISABLE_REQUESTS = `${MENU_EQUIPMENTS}/fetchEquipmentPermanentDisableRequests`
export const FETCH_EQUIPMENT_PERMANENT_DISABLE_REQUEST_BY_ID = `${MENU_EQUIPMENTS}/fetchEquipmentPermanentDisableRequestById`
export const APPROVE_EQUIPMENT_PERMANENT_DISABLE_REQUEST = `${MENU_EQUIPMENTS}/approveEquipmentPermanentDisableRequest`
export const REJECT_EQUIPMENT_PERMANENT_DISABLE_REQUEST = `${MENU_EQUIPMENTS}/rejectEquipmentPermanentDisableRequest`
